import { render, staticRenderFns } from "./DetailAdherent.vue?vue&type=template&id=72df8cf6&scoped=true"
import script from "./DetailAdherent.vue?vue&type=script&lang=js"
export * from "./DetailAdherent.vue?vue&type=script&lang=js"
import style0 from "./DetailAdherent.vue?vue&type=style&index=0&id=72df8cf6&prod&scoped=true&lang=css"
import style1 from "./DetailAdherent.vue?vue&type=style&index=1&id=72df8cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_babel-core@7.0.0-bridge.0_@babel+core@7.29._a26fb9023b752f5df33ae8450879cd09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df8cf6",
  null
  
)

export default component.exports